<template>
  <v-dialog v-model="dialog" width="350px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" class="ml-5 focus-delete">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card tile>
      <v-card-title>Update Listing</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5 pb-0">
        <v-form v-model="valid" ref="form">
          <v-text-field :rules="rules" outlined label="Name" dense v-model="form.name"></v-text-field>
          <DatePicker v-model="form.date" label="Listing Date" />

          <v-text-field
            outlined
            label="No of Applications"
            dense
            type="number"
            v-model="form.count"
          ></v-text-field>
          <div class="mt-0">Property status</div>
          <v-radio-group v-model="form.status" @change="change" row class="mt-0">
            <v-radio value="yes" label="Rented"></v-radio>
            <v-radio value="no" label="Not Rented"></v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" @click="dialog = false" text>Cancel</v-btn>
        <v-btn color="success" @click="submit()" text>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { db } from "../assets/js/firebase";
import DatePicker from "./Date";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      valid: false,
      dialog: false,
      form: {
        name: "",
        date: "",
        count: 0,
        status: "no"
      },
      rules: [v => !!v || "Field is required"]
    };
  },
  computed: {
    loader: {
      set(val) {
        this.$root.loader = val;
      },
      get() {
        return false;
      }
    },
    alert: {
      set(val) {
        this.$root.alert(val);
      },
      get() {
        return false;
      }
    }
  },
  watch: {
    dialog() {
      this.init();
    }
  },
  methods: {
    change(e) {
      this.form.status = e;
    },
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.valid) return;
      let { key } = vm.item;
      let doc = {};
      doc.check = vm.form.name.trim().toLowerCase();
      Object.keys(vm.form).forEach(key => {
        doc[key] = vm.form[key];
      });
      if (doc.count === "") doc.count = 0;
      doc.count = Number(doc.count);
      vm.loader = true;
      try {
        let query = await vm.query(doc).once("value");
        if (query.numChildren() !== 0) {
          let id = "";
          query.forEach(snap => {
            id = snap.key;
          });
          if (key !== id) {
            vm.loader = false;
            vm.alert = "Name already exits";
            return;
          }
        }
        await db
          .child("property")
          .child(key)
          .update(doc);
        vm.loader = false;
        vm.alert = "Property Updated Successfully!";
        vm.dialog = false;
      } catch ({ message }) {
        vm.loader = false;
        vm.alert = message;
      }
    },
    query({ check }) {
      return db
        .child("property")
        .orderByChild("check")
        .equalTo(check)
        .limitToLast(1);
    },
    init() {
      const vm = this;
      Object.keys(vm.form).forEach(key => {
        vm.form[key] = vm.item[key];
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
.focus-delete {
  float: left;
}
</style>
